import httpClient from "../axiosBase/axiosHandler";

export const getFigureflowInterface = () => {
  return httpClient.get("/figure-flow/embed-token/");
};
